import React from 'react';

import {ProcessPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isProcessPlatformFeatureEnabledAndHasCapability} from 'processes/processes-platform/FeatureOptions';
import {MinimalEntity} from 'ui-library/entity-input/EntityInputConstants';
import {UserSearchType} from 'ui-library/entity-input/EntityInputWithSearch';
import EditablePartyField from 'ui-library/inputs/EditablePartyField';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';

import {ProcessTaskFieldProps} from '../ProcessTaskDetailsPageConstants';

export default function AssigneeField(props: ProcessTaskFieldProps): JSX.Element {
  return (
    <EditablePartyField
      value={props.processTask.assignee}
      onChange={async (selectedAssignee: MinimalEntity | null) => {
        await props.onUpdateTask({id: props.processTask.id, assigneeId: selectedAssignee?.id ?? null});
      }}
      useAvatars={true}
      isDisabled={
        !isProcessPlatformFeatureEnabledAndHasCapability(
          ProcessPlatformFeatureType.CAN_EDIT_ASSIGNEE,
          props.processTask.schema.executionType,
          props.processTask.schema.clientOrigin,
          props.processTask.schema.name
        )
      }
      chipSize={TagsInputSize.SMALL}
      enableNewEntityInput={true}
      allowEmails={false}
      allowTeams={false}
      allowOrganizations={false}
      shouldAllowMultiple={false}
      placeholder="Search for user"
      userSearchType={UserSearchType.NotSuspended}
      isFullWidth={false}
      initialIsBeingEdited={false}
      allowEmptyValue={true}
      shouldUseCompactDisplay={true}
    />
  );
}
